<template>
  <div class="mensalidades-isp">
    <h1 class="titulo-card fs-4">Assinaturas / Mensalidades</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="$router.go(-1)" class="btn btn-outline-primary">
            <font-awesome-icon :icon="['fas', 'arrow-left']" fixed-width class="me-1"/>Voltar
          </button>
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <!--
        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
        -->
      </div>
      <div v-if="assinatura && cliente && endereco && plano" class="alert alert-success">
        <p class="mb-0"><b>Assinatura:</b> #{{assinatura.id}}</p>
        <p class="mb-0"><b>Contratado:</b> {{assinatura.data_contratado}}</p>
        <p class="mb-0"><b>Plano:</b> {{plano.descricao}} / <b>R$</b> {{formataMoeda(assinatura.valor)}}</p>
        <p class="mb-0"><b>Cliente:</b> {{cliente.razao_social}}</p>
        <p class="mb-0"><b>Local instalação:</b> {{formataEndereco(endereco)}}</p>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">#</th>
              <th>Mês de referência</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Status</th>
              <th width="115"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mensalidade in mensalidades" :key="mensalidade.id" :class="cssMensalidade(mensalidade)">
              <td scope="row">{{mensalidade.id}}</td>
              <td>{{formataMesReferencia(mensalidade.mes_referencia)}}</td>
              <td>{{mensalidade.vencimento}}</td>
              <td>{{formataMoeda(mensalidade.valor)}}</td>
              <td>
                <font-awesome-icon v-if="(mensalidade.status === 'smAberto')" :icon="['fas', 'clock']" fixed-width/>
                <font-awesome-icon v-if="(mensalidade.status === 'smRecebido-x')" :icon="['fas', 'times-circle']" fixed-width/>
                <font-awesome-icon v-if="(mensalidade.status === 'smRecebido')" :icon="['fas', 'check-circle']" fixed-width/>
                {{traduzStatusMensalidade(mensalidade.status)}}
              </td>
              <td class="text-end">
                <button type="button" v-on:click="modalCobrancasAbreHandle(mensalidade)" class="btn btn-outline-primary btn-sm me-1">
                  <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                </button>
                <button type="button" v-if="podeEditarMensalidade(mensalidade)" v-on:click="handleEditaMensalidade(mensalidade)" class="btn btn-primary btn-sm me-1">
                  <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                </button>
                <button type="button" v-if="podeEditarMensalidade(mensalidade)" v-on:click="handleRemoveMensalidade(mensalidade)" class="btn btn-danger btn-sm">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

      <!-- modal-edita-mensalidade -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-mensalidade" id="btn-modal-edita-mensalidade-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-edita-mensalidade" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="!modal.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Cadastrar nova Mensalidade
              </h5>
              <h5 v-if="!!modal.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
                Editando Mensalidade
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-2">
                  <label class="required">Quantidade</label>
                  <input type="number" v-model.number="modal.data.quantidade" v-bind:disabled="modal.data.id" min="1" max="24" class="form-control" placeholder="Insira a quantidade">
                </div>
                <div class="col-12 col-sm-3 col-md-2">
                  <label class="required">Valor</label>
                  <currency-input v-model="modal.data.valor" class="form-control" placeholder="Valor da mensalidade"/>
                </div>
                <div class="col-12 col-sm-5 col-md-5">
                  <label class="required">Mês referência</label>
                  <input type="month" v-model="modal.data.mes_referencia" class="form-control">
                </div>
                <div class="col-12 col-sm-4 col-md-3">
                  <label class="required">Vencimento</label>
                  <input type="date" v-model="modal.data.vencimento" class="form-control">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-mensalidade-fecha">Fechar</button>
              <button type="button"
                  v-if="!modal.data.id"
                  v-on:click="handlemodalCadastrar()"
                  v-bind:disabled="!podeSalvarMensalidade()"
                  class="btn btn-success">
                Cadastrar
              </button>
              <button type="button"
                  v-if="!!modal.data.id"
                  v-on:click="handlemodalSalvar()"
                  v-bind:disabled="!podeSalvarMensalidade()"
                  class="btn btn-success">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-edita-mensalidade -->

      <!-- modal-cobrancas-mensalidade-isp -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-cobrancas-mensalidade-isp" id="btn-modal-cobrancas-mensalidade-isp-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-cobrancas-mensalidade-isp" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Cobrança de mensalidade
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div v-if="modalCobrancas.mensalidade" class="modal-body">
              <div class="alert alert-success">
                <p class="mb-0"><b>Mensalidade:</b> {{formataMesReferencia(modalCobrancas.mensalidade.mes_referencia)}}</p>
                <p class="mb-0"><b>Vencimento:</b> {{modalCobrancas.mensalidade.vencimento}}</p>
                <p class="mb-0"><b>Valor:</b> R$ {{formataMoeda(modalCobrancas.mensalidade.valor)}}</p>
                <p class="mb-0"><b>Status:</b> {{traduzStatusMensalidade(modalCobrancas.mensalidade.status)}}</p>
              </div>

              <div v-if="(modalCobrancas.mensalidade.status === 'smAberto')" class="btn-group float-end" role="group" aria-label="Basic example">
                <button disabled v-on:click="modalNovaCobrancaMensalidadeAbreHandle()" type="button" class="btn btn-sm btn-outline-primary">
                  <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                  Nova cobrança
                </button>
                <button v-on:click="modalNovoRecebimentoMensalidadeAbreHandle()" type="button" class="btn btn-sm btn-success">
                  <font-awesome-icon :icon="['fas', 'hand-holding-usd']" fixed-width/>
                  Receber
                </button>
              </div>

              <table class="table table-sm-pc table-striped table-hover">
                <thead>
                  <tr>
                    <th width="25">#</th>
                    <th>Forma de cobrança</th>
                    <th>Status</th>
                    <th width="80" class="text-center">Valor</th>
                    <th width="115"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cobranca in modalCobrancas.cobrancas" :key="cobranca.id" :class="cssCobranca(cobranca)">
                    <td scope="row">{{cobranca.id}}</td>
                    <td>{{cobranca.tipo}}</td>
                    <td>{{traduzStatusCobranca(cobranca.status)}}</td>
                    <td class="text-center">R$ {{formataMoeda(cobranca.valor)}}</td>
                    <td class="text-end">
                      <button type="button" v-if="(modalCobrancas.mensalidade.status === 'smAberto')"  v-on:click="modalCobrancasReceberHandle(cobranca)" class="btn btn-success btn-sm me-1">
                        <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                      </button>
                      <button type="button" v-if="(modalCobrancas.mensalidade.status === 'smAberto')"  v-on:click="modalCobrancasRemoverHandle(cobranca)" class="btn btn-danger btn-sm">
                        <font-awesome-icon :icon="['fas', 'eye-slash']" fixed-width/>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button"
                  id="btn-modal-cobrancas-mensalidade-isp-fecha"
                  class="btn btn-outline-secondary"
                  data-bs-dismiss="modal">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-cobrancas-mensalidade-isp -->


      <!-- modal-nova-cobranca-mensalidade -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-nova-cobranca-mensalidade" id="btn-modal-nova-cobranca-mensalidade-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-nova-cobranca-mensalidade" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Nova cobrança de mensalidade
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div v-if="modalCobrancas.mensalidade" class="modal-body">
              <p class="mb-0"><b>Mensalidade:</b> #{{modalCobrancas.mensalidade.id}}</p>
              <p class="mb-0"><b>Vencimento:</b> {{modalCobrancas.mensalidade.vencimento}}</p>
              <p class="mb-0"><b>Valor:</b> R$ {{formataMoeda(modalCobrancas.mensalidade.valor)}}</p>
              <hr>
              <div class="row mt-3">
                <div class="col-12 col-sm-6 col-lg-3">
                  <label class="required">Tipo de cobrança</label>
                  <select v-model="modalNovaCobrancaMensalidade.data.tipo" class="form-select">
                    <option value="" disabled>Selecione</option>
                    <option value="tcBoleto">Boleto</option>
                  </select>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <label class="required">Vencimento</label>
                  <input type="date" v-model="modalNovaCobrancaMensalidade.data.data_vencimento" class="form-control">
                </div>
                <div class="col-12 col-sm-4 col-lg-2">
                  <label>Adicional</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                    </span>
                    <currency-input v-model="modalNovaCobrancaMensalidade.data.adicional" class="form-control text-end"/>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-lg-2">
                  <label>Desconto</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                    </span>
                    <currency-input v-model="modalNovaCobrancaMensalidade.data.desconto" class="form-control text-end"/>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-lg-2">
                  <label>Total</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                    </span>
                    <input type="text" v-bind:value="formataMoeda(modalNovaCobrancaMensalidadeTotal)" disabled class="form-control text-end">
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                  v-bind:disabled="(!modalNovaCobrancaMensalidadePodeCriarCobranca())"
                  v-on:click="modalRecebeCobrancaReceberHandle()"
                  type="button"
                  class="btn btn-success">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Criar cobrança
              </button>
              <button type="button"
                  v-on:click="modalCobrancasFechaHandle()"
                  id="btn-modal-nova-cobranca-mensalidade-fecha"
                  class="btn btn-outline-secondary"
                  data-bs-dismiss="modal">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-nova-cobranca-mensalidade -->


      <!-- modal-recebe-mensalidade -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-recebe-mensalidade" id="btn-modal-recebe-mensalidade-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-recebe-mensalidade" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <font-awesome-icon :icon="['fas', 'hand-holding-usd']" fixed-width/>
                Receber mensalidade
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div v-if="modalCobrancas.mensalidade" class="modal-body">
              <p class="mb-0"><b>Mensalidade:</b> #{{modalCobrancas.mensalidade.id}}</p>
              <p class="mb-0"><b>Vencimento:</b> {{modalCobrancas.mensalidade.vencimento}}</p>
              <p class="mb-0"><b>Valor:</b> R$ {{formataMoeda(modalCobrancas.mensalidade.valor)}}</p>
              <hr>
              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-3">
                  <label class="required">Data recebimento</label>
                  <input type="date" v-model="modalNovoRecebimentoMensalidade.data.data_recebimento" class="form-control">
                </div>
                <div class="col-12 col-sm-4 col-md-3">
                  <label>Adicional</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                    </span>
                    <currency-input v-model="modalNovoRecebimentoMensalidade.data.adicional" class="form-control text-end"/>
                    <!--
                    <input type="text" v-model="modalNovoRecebimentoMensalidade.data.adicional" class="form-control text-end">
                    -->
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-md-3">
                  <label>Desconto</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                    </span>
                    <currency-input v-model="modalNovoRecebimentoMensalidade.data.desconto" class="form-control text-end"/>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-md-3">
                  <label>Total</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                    </span>
                    <input type="text" v-bind:value="formataMoeda(modalNovoRecebimentoMensalidadeTotal)" disabled class="form-control text-end">
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                  v-bind:disabled="(!modalNovoRecebimentoMensalidadePodeCriarCobranca())"
                  v-on:click="modalNovoRecebimentoMensalidadeReceberHandle()"
                  type="button"
                  class="btn btn-success">
                <font-awesome-icon :icon="['fas', 'check']" fixed-width/>
                Receber
              </button>
              <button type="button"
                  v-on:click="modalCobrancasFechaHandle()"
                  id="btn-modal-recebe-mensalidade-fecha"
                  class="btn btn-outline-secondary"
                  data-bs-dismiss="modal">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-recebe-mensalidade -->


      <!-- modal-recebe-cobranca -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-recebe-cobranca" id="btn-modal-recebe-cobranca-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-recebe-cobranca" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/>
                Receber cobrança
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div v-if="modalRecebeCobranca.cobranca" class="modal-body">
              <p class="mb-0"><b>Cobrança:</b> #{{modalRecebeCobranca.cobranca.id}}</p>
              <p class="mb-0"><b>Tipo:</b> {{modalRecebeCobranca.cobranca.tipo}}</p>
              <p class="mb-0"><b>Status:</b> {{modalRecebeCobranca.cobranca.status}}</p>
              <p class="mb-0"><b>Valor:</b> R$ {{formataMoeda(modalRecebeCobranca.cobranca.valor)}}</p>
            </div>
            <div class="modal-footer">
              <div class="row g-0 justify-content-between w-100">
                <div class="col-auto">
                  <button v-on:click="modalRecebeCobrancaReceberHandle()" type="button" class="btn btn-success">
                    <font-awesome-icon :icon="['fas', 'check']" fixed-width/>
                    Receber cobrança
                  </button>
                </div>
                <div class="col-auto">
                  <button type="button"
                      v-on:click="modalCobrancasFechaHandle()"
                      id="btn-modal-recebe-cobranca-fecha"
                      class="btn btn-outline-secondary"
                      data-bs-dismiss="modal">
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-recebe-cobranca -->
    </div>
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'MensalidadesISP',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      assinatura: undefined,
      cliente: undefined,
      endereco: undefined,
      plano: undefined,
      mensalidades: [],
      modal: {
        data: {
          id: undefined,
          quantidade: undefined,
          valor: 0,
          mes_referencia: '',
          vencimento: '',
        },
      },
      modalCobrancas: {
        mensalidade: undefined,
        cobrancas: [],
        paginador: clone(model.paginador),
      },
      modalNovoRecebimentoMensalidade: {
        data: {
          data_recebimento: undefined,
          adicional: 0,
          desconto: 0,
        },
      },
      modalNovaCobrancaMensalidade: {
        data: {
          tipo: '',
          data_vencimento: undefined,
          adicional: 0,
          desconto: 0,
        },
      },
      modalRecebeCobranca: {
        cobranca: undefined,
      },
    }
  },

  methods: {
    carregaAssinatura() {
      const assinaturaID = +this.$route.params.assinaturaID;

      if (!assinaturaID) {
        this.$router.push({ path: `/assinaturas-isp` });
        return;
      }

      loading(true);

      api.get(`/assinaturas-isp/${assinaturaID}`).then(res => {
        this.assinatura = res.data;

        this.handlePesquisa();
        this.carregaCliente();
        this.carregaEndereco();
        this.carregaPlano();
      }).catch(error => {
        loading(false);

        dialogo.erroHttp(error).then(() => {
          this.$router.push({ path: `/assinaturas-isp` });
        });
      });
    },

    carregaCliente() {
      api.get(`/clientes/${this.assinatura.cliente_id}`).then(res => {
        loading(false);
        this.cliente = res.data;
      }).catch(error => {
        loading(false);

        dialogo.erroHttp(error).then(() => {
          this.$router.push({ path: `/assinaturas-isp` });
        });
      });
    },

    carregaEndereco() {
      api.get(`/clientes/${this.assinatura.cliente_id}/enderecos/${this.assinatura.endereco_id}`).then(res => {
        loading(false);
        this.endereco = res.data;
      }).catch(error => {
        loading(false);

        dialogo.erroHttp(error).then(() => {
          this.$router.push({ path: `/assinaturas-isp` });
        });
      });
    },

    carregaPlano() {
      api.get(`/plano-isp/${this.assinatura.plano_id}`).then(res => {
        loading(false);
        this.plano = res.data;
      }).catch(error => {
        loading(false);

        dialogo.erroHttp(error).then(() => {
          this.$router.push({ path: `/assinaturas-isp` });
        });
      });
    },

    handlePesquisa() {
      loading(true);

      api.get(`/assinaturas-isp/${this.assinatura.id}/mensalidades?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.mensalidades = res.data.itens;
        //this.paginador.pagina = res.data.paginacao.pagina;
        //this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.resetModalMensalidade();
      this.abreModalCadastroMensalidade();
    },

    async handleEditaMensalidade(mensalidade) {
      this.resetModalMensalidade();

      const indice = mensalidade.mes_referencia.lastIndexOf('-');
      const mesReferencia = mensalidade.mes_referencia.slice(0, indice);

      this.modal.data = clone(mensalidade);
      this.modal.data.quantidade = 1;
      this.modal.data.mes_referencia = mesReferencia;

      this.abreModalCadastroMensalidade();
    },

    handleRemoveMensalidade(mensalidade) {
      dialogo.confirmacao(`Confirma remover o Grupo <b>${mensalidade.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/assinaturas-isp/${this.assinatura.id}/mensalidades/${mensalidade.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroMensalidade() {
      document.getElementById('btn-modal-edita-mensalidade-abre').click();
    },

    resetModalMensalidade() {
      const hoje = new Date();
      const vencimentoStr = hoje.getUTCFullYear() + '-' + this.padLeft(hoje.getUTCMonth() + 1, 2, '0') +'-'+ this.assinatura.dia_vencimento;
      const mesReferencia = new Date(hoje.setMonth(hoje.getMonth()-1));
      const mesReferenciaStr = mesReferencia.getUTCFullYear() + '-' + this.padLeft(mesReferencia.getUTCMonth() + 1, 2, '0');

      this.modal.data.quantidade = 1;
      this.modal.data.valor = this.assinatura.valor;
      this.modal.data.mes_referencia = mesReferenciaStr;
      this.modal.data.vencimento = vencimentoStr;
    },

    podeSalvarMensalidade() {
      switch (true) {
        case (this.modal.data.quantidade <= 0):
        case (!this.modal.data.mes_referencia):
        case (!this.modal.data.vencimento):
          return false;

        default:
          return true;
      }
    },

    handlemodalCadastrar() {
      const sendData = {
        valor: this.modal.data.valor,
        vencimento: this.modal.data.vencimento,
        quantidade: this.modal.data.quantidade,
        mes_referencia: this.modal.data.mes_referencia + '-01',
      };

      loading(true);

      api.post(`/assinaturas-isp/${this.assinatura.id}/mensalidades`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-mensalidade-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handlemodalSalvar() {
      const sendData = {
        id: this.modal.data.id,
        valor: this.modal.data.valor,
        vencimento: this.modal.data.vencimento,
        quantidade: this.modal.data.quantidade,
        mes_referencia: this.modal.data.mes_referencia + '-01',
      };

      loading(true);
      api.put(`/assinaturas-isp/${this.assinatura.id}/mensalidades/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-mensalidade-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    cssMensalidade(mensalidade) {
      switch (mensalidade.status) {
        case 'smAberto':
          return 'text-secondary';

        case 'smRecebido':
          return 'text-success';

        default:
          return '';
      }
    },

    traduzStatusMensalidade(status) {
      switch (status) {
        case 'smAberto':
          return 'Aberto';

        case 'smRecebido':
          return 'Recebido';

        default:
          return '';
      }
    },

    cssCobranca(cobranca) {
      switch (cobranca.status) {
        case 'scCancelado':
          return 'text-muted-2';

        case 'scRecebido':
          return 'text-success';

        default:
          return '';
      }
    },

    traduzStatusCobranca(status) {
      switch (status) {
        case 'scAberto':
          return 'Aberto';

        case 'scCancelado':
          return 'Cancelado';

        case 'scRecebido':
          return 'Recebido';

        default:
          return '';
      }
    },

    podeEditarMensalidade(mensalidade) {
      switch (mensalidade.status) {
        case 'smAberto':
          return true;

        default:
          return false;
      }
    },

    /////////////////////////////////////
    // modal cobranças
    modalCobrancasReset() {
      this.modalCobrancas.cobrancas = [];
    },

    modalCobrancasAbre() {
      document.getElementById('btn-modal-cobrancas-mensalidade-isp-abre').click();
    },

    modalCobrancasFecha() {
      document.getElementById('btn-modal-cobrancas-mensalidade-isp-fecha').click();
    },

    modalCobrancasLista() {
      const assinaturaID = +this.$route.params.assinaturaID;

      const apiUrl = `` +
          `/assinaturas-isp/${assinaturaID}` +
          `/mensalidades/${this.modalCobrancas.mensalidade.id}/cobrancas`;

      if (!assinaturaID) {
        this.$router.push({ path: `/assinaturas-isp` });
        return;
      }

      loading(true);

      api.get(apiUrl).then(res => {
        this.modalCobrancas.cobrancas = res.data.itens;
        this.modalCobrancas.paginador.pagina = res.data.paginacao.pagina;
        this.modalCobrancas.paginador.totalItens = res.data.paginacao.total;

        this.modalCobrancasAbre();
        loading(false);
      }).catch(error => {
        loading(false);

        dialogo.erroHttp(error).then(() => {
          //this.modalCobrancasFecha();
        });
      });
    },

    modalCobrancasAbreHandle(mensalidade) {
      this.modalCobrancas.mensalidade = clone(mensalidade);

      this.modalCobrancasReset();
      this.modalCobrancasLista();
    },

    modalCobrancasReceberHandle(cobranca) {
      this.modalCobrancasFecha();
      this.modalRecebeCobrancaAbreHandle(cobranca);
    },

    modalCobrancasRemoverHandle() {
    //modalCobrancasRemoverHandle(cobranca) {
      dialogo.confirmacao(`Confirma cancelar esta cobrança?`).then(() => {
        /*loading(true);

        api.delete(`/`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });*/
      });
    },
    // modal cobranças
    /////////////////////////////////////


    /////////////////////////////////////
    // modal novo recebimento mensalidade
    modalNovoRecebimentoMensalidadeReset() {
      this.modalNovoRecebimentoMensalidade.data.data_recebimento = this.dateToMySQLDateStr(new Date());
      this.modalNovoRecebimentoMensalidade.data.adicional = 0;
      this.modalNovoRecebimentoMensalidade.data.desconto = 0;
    },

    modalNovoRecebimentoMensalidadeAbre() {
      document.getElementById('btn-modal-recebe-mensalidade-abre').click();
    },

    modalNovoRecebimentoMensalidadeFecha() {
      document.getElementById('btn-modal-recebe-mensalidade-fecha').click();
    },

    modalNovoRecebimentoMensalidadeAbreHandle() {
      this.modalNovoRecebimentoMensalidadeReset();
      this.modalCobrancasFecha();
      this.modalNovoRecebimentoMensalidadeAbre();
    },

    modalNovoRecebimentoMensalidadeFechaHandle() {
      this.modalCobrancasAbre();
    },

    modalNovoRecebimentoMensalidadePodeCriarCobranca() {
      const data = this.modalNovoRecebimentoMensalidade.data;

      switch (true) {
        case (!data.data_recebimento):
        case (data.adicional < 0):
        case (data.desconto < 0):
          return false;

        default:
          return true;
      }
    },

    modalNovoRecebimentoMensalidadeReceberHandle() {
      const assinaturaID = this.assinatura.id;
      const mensalidadeID = this.modalCobrancas.mensalidade.id;
      const data = this.modalNovoRecebimentoMensalidade.data;

      const apiUrl = `/assinaturas-isp/${assinaturaID}/mensalidades/${mensalidadeID}/recebimentos`;

      const sendData = {
        data_recebimento: data.data_recebimento,
        adicional: data.adicional,
        desconto: data.desconto,
        valor: this.modalCobrancas.mensalidade.valor,
      };

      loading(true);

      api.post(apiUrl, sendData).then(() => {
        loading(false);
        //this.modalNovoRecebimentoMensalidadeFecha();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });

    },



    /*modalNovoRecebimentoMensalidadeEditarHandle() {
      dialogo.confirmacao(`Confirma efetuar o recebimento desta cobrança?`).then(() => {
        const apiUrl = ``;

        const sendData = {
          cobranca_id: 0,
        };

        loading(true);

        api.post(apiUrl, sendData).then(() => {
          loading(false);
          this.modalNovoRecebimentoMensalidadeFecha();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },*/
    // modal novo recebimento mensalidade
    /////////////////////////////////////


    /////////////////////////////////////
    // modal edita cobranca
    modalNovaCobrancaMensalidadeReset() {
      this.modalNovaCobrancaMensalidade.data.tipo = '';
      this.modalNovoRecebimentoMensalidade.data.data_vencimento = undefined;
      this.modalNovoRecebimentoMensalidade.data.adicional = 0;
      this.modalNovoRecebimentoMensalidade.data.desconto = 0;
    },

    modalNovaCobrancaMensalidadeAbre() {
      document.getElementById('btn-modal-nova-cobranca-mensalidade-abre').click();
    },

    modalNovaCobrancaMensalidadeFecha() {
      document.getElementById('btn-modal-nova-cobranca-mensalidade-fecha').click();
    },

    modalNovaCobrancaMensalidadeAbreHandle() {
      this.modalNovaCobrancaMensalidadeReset();
      this.modalCobrancasFecha();
      this.modalNovaCobrancaMensalidadeAbre();
    },

    modalNovaCobrancaMensalidadeFechaHandle() {
      this.modalCobrancasAbre();
    },

    modalNovaCobrancaMensalidadePodeCriarCobranca() {
      return false;
    },



    /*modalNovaCobrancaMensalidadeEditarHandle() {
      dialogo.confirmacao(`Confirma efetuar o recebimento desta cobrança?`).then(() => {
        const apiUrl = ``;

        const sendData = {
          cobranca_id: 0,
        };

        loading(true);

        api.post(apiUrl, sendData).then(() => {
          loading(false);
          this.modalNovaCobrancaMensalidadeFecha();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },*/
    // modal edita cobranca
    /////////////////////////////////////


    /////////////////////////////////////
    // modal recebe cobrança
    modalRecebeCobrancaReset() {
      this.modalRecebeCobranca.cobranca = undefined;
    },

    modalRecebeCobrancaAbre() {
      document.getElementById('btn-modal-recebe-cobranca-abre').click();
    },

    modalRecebeCobrancaFecha() {
      document.getElementById('btn-modal-recebe-cobranca-fecha').click();
    },

    modalRecebeCobrancaAbreHandle(cobranca) {
      this.modalRecebeCobrancaReset();

      this.modalRecebeCobranca.cobranca = cobranca;

      this.modalRecebeCobrancaAbre();
    },

    modalCobrancasFechaHandle() {
      this.modalCobrancasAbre();
    },

    modalRecebeCobrancaReceberHandle() {
      dialogo.confirmacao(`Confirma efetuar o recebimento desta cobrança?`).then(() => {
        const apiUrl = ``;

        const sendData = {
          cobranca_id: 0,
        };

        loading(true);

        api.post(apiUrl, sendData).then(() => {
          loading(false);
          this.modalRecebeCobrancaFecha();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },
    // modal recebe cobrança
    /////////////////////////////////////



    //TODO: tornar esta função como global
    /**
     * @param {Number} numero
     * @param {Number} zeros
     * @returns {string} Strins com "zeros" à esquerda do número informado
     **/
    strZero(numero, zeros){
        return Array(zeros-String(numero).length+1).join('0') + numero;
    },

    //TODO: tornar esta função como global
    /**
     * @param {Date} data
     * @returns {string} Data no formato YYYY-MM-DD
     **/
    dateToMySQLDateStr(data) {
      const dia = this.strZero(data.getDate(), 2);
      const mes = this.strZero(data.getMonth()+1, 2);

      return `${data.getFullYear()}-${mes}-${dia}`;
    },

    //TODO: fazer esta função ser global
    formataEndereco(endereco) {
      let resultado = '';

      // resultado += `${endereco.id} - `;
      resultado += endereco.logradouro;

      if (endereco.numero) {
        resultado += `, ${endereco.numero}`;
      }

      if (endereco.complemento) {
        resultado += ` ${endereco.complemento}`;
      }

      resultado += ` - ${endereco.bairro}`;
      resultado += ` - ${endereco.cidade}`;
      resultado += ` - ${endereco.uf}`;

      return resultado;
    },

    formataMesReferencia(entrada, abreviado) {
      const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      const mesesAbr = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      var data = new Date();

      if (typeof entrada === "object") {
        data = entrada;
      } else {
        data = new Date(entrada);
      }

      if (abreviado) {
        return mesesAbr[data.getUTCMonth()] +'/'+ data.getUTCFullYear();
      }

      return meses[data.getUTCMonth()] +'/'+ data.getUTCFullYear();
    },

    //TODO: fazer esta função ser global
    insereChar(texto, char, posicao) {
        return texto.slice(0, posicao) + char + texto.slice(posicao);
    },

    padLeft(variavel, qtdChars, str){
        variavel = String(variavel);
        if (variavel.length >= qtdChars) {
            return variavel;
        }
        return Array(qtdChars - variavel.length + 1).join(str||'0') + variavel;
    },

    formataMoeda(valorInt) {
        if (!valorInt) {
            valorInt = 0;
        }
        let negativo = false;
        if (valorInt < 0) {
            negativo = true;
            valorInt = valorInt * (-1);
        }

        let vOut = this.padLeft(valorInt, 3) || '000';
        vOut = this.insereChar(vOut, ',', vOut.length - 2);
        let charLen = 6;
        let textLen = vOut.length;

        while (textLen > charLen) {
            vOut = this.insereChar(vOut, '.', textLen - charLen);
            charLen += 4;
            textLen = vOut.length;
        }

        if (negativo === true) {
            vOut = '-' + vOut;
        }

        return vOut;
    },

    moedaToInt(valor) {
        valor = String(valor);

        if (!valor) {
            valor = '0,00';
        }

        var valorInt = +valor.replace(/[^0-9]/g, '');

        if (typeof valorInt === 'number') {
            return valorInt;
        }

        return 0;
    }
  },
  computed: {
    modalNovoRecebimentoMensalidadeTotal() {
      const valor = this.modalCobrancas.mensalidade.valor;
      const adicional = this.moedaToInt(this.modalNovoRecebimentoMensalidade.data.adicional);
      const desconto = this.moedaToInt(this.modalNovoRecebimentoMensalidade.data.desconto);
      const total = valor + adicional - desconto;

      return total;
    },
    modalNovaCobrancaMensalidadeTotal() {
      const valor = this.modalCobrancas.mensalidade.valor;
      const adicional = this.moedaToInt(this.modalNovaCobrancaMensalidade.data.adicional);
      const desconto = this.moedaToInt(this.modalNovaCobrancaMensalidade.data.desconto);
      const total = valor + adicional - desconto;

      return total;
    },
  },
  created() {
    this.carregaAssinatura();

    /*
    setTimeout(() => {
      this.modalCobrancasAbreHandle(this.mensalidades[0]);
    }, 500);

    setTimeout(() => {
      this.modalCobrancasFecha();
      // this.modalNovaCobrancaMensalidadeAbreHandle();
      this.modalNovoRecebimentoMensalidadeAbreHandle();
    }, 1200);
    */
  }

}


</script>
